import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import ProductImage from "../../assets/images/aboutus-page/product.png";
import SMSSnippetImage from "../../assets/images/aboutus-page/sms_snippet.png";

const PREFIX = "ContentImageSection";

const classes = {
  root: `${PREFIX}-root`,
  heading: `${PREFIX}-heading`,
  content: `${PREFIX}-content`,
  image: `${PREFIX}-image`,
  button: `${PREFIX}-button`,
  mainContainer: `${PREFIX}-mainContainer`,
  imgContainer: `${PREFIX}-imgContainer`,
  title: `${PREFIX}-title`,
  divider: `${PREFIX}-divider`,
  container: `${PREFIX}-container`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.root}`]: {
    padding: "2em",
    [theme.breakpoints.down("sm")]: {
      padding: "1em",
    },
  },
  [`& .${classes.divider}`]: {
    borderBottom: "1px solid red",
    width: "15%",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.title}`]: {
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 32,
  },
  [`& .${classes.container}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "flexStart",
    marginTop: "1%",
    marginLeft: "2em",
  },
  [`& .${classes.heading}`]: {
    fontSize: 32,
    fontWeight: "500",
    marginBottom: "2rem",
    fontFamily: "AvenirLTStd-Roman",
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
    },
  },
  [`& .${classes.content}`]: {
    fontSize: 20,
    fontFamily: "AvenirLTStd-Book",
    marginBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  [`& .${classes.image}`]: {
    width: "100%",
    height: "auto",
    maxWidth: 500,
    [theme.breakpoints.down("sm")]: {
      maxWidth: 300,
    },
  },
  [`& .${classes.button}`]: {
    background: "#B41E1C",
    color: "#fff",
    textTransform: "capitalize",
    fontFamily: "AvenirLTStd-Roman",
    marginTop: "2em",
    padding: "0.5rem",
    fontWeight: "none",
    borderRadius: "24px",
    fontSize: 15,
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      marginLeft: 0,
    },
  },
  [`& .${classes.mainContainer}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 2rem 0 2rem",
  },
  [`& .${classes.imgContainer}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const ourProducts = [
  {
    title: "The REDiFly eTechlog",
    content:
      "Our eTechlog (ETL) replaces paper-based aircraft tech logbooks, enhancing airworthiness, enabling preventive maintenance, and future-proofing performance with real-time data. It integrates with your MRO, scheduling, and crew systems for a fully paperless, connected operation.",
    image: ProductImage,
  },
  {
    title: "The REDiFly SMS",
    content:
      "Our Safety Management System (SMS) is built for small to mid-sized aviation organisations. It simplifies compliance with EASA regulations and turns safety processes into a proactive, integrated part of daily operations. From hazard reporting to risk tracking and MoC, it delivers the oversight you need without the complexity.",
    image: SMSSnippetImage,
  },
];

const OurProducts = () => {
  const navigate = useNavigate();

  return (
    <StyledGrid container className={classes.root}>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className={classes.container}
      >
        <Typography variant="h5" className={classes.title}>
          Our Products
        </Typography>{" "}
        <Grid className={classes.divider} />
      </Grid>
      {ourProducts.map((product, index) => (
        <Grid
          container
          key={index}
          spacing={2}
          className={classes.mainContainer}
        >
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Typography variant="h4" className={classes.heading}>
              {product.title}
            </Typography>
            <Typography variant="body1" className={classes.content}>
              {product.content}
            </Typography>
            <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
              <Button
                variant="contained"
                className={classes.button}
                endIcon={<ArrowForward />}
                onClick={() => {
                  navigate("/path-to-navigate");
                  window.scrollTo(0, 0);
                }}
              >
                Schedule a Discovery Call
              </Button>
            </Grid>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6, md: 6, lg: 6 }}
            className={classes.imgContainer}
          >
            <img
              src={product.image}
              alt={product.title}
              className={classes.image}
            />
          </Grid>
        </Grid>
      ))}
    </StyledGrid>
  );
};

export default OurProducts;
